import { FCX } from "@datassential/platform-ui-lib";
import Widget from "@components/Widget/Widget";
import SocialPosts from "@components/SocialPosts/SocialPosts";
import { ISocialPost } from "@models/SocialPosts";
import { ReactNode } from "react";
import './TopFoodBeveragePosts.scss';
import cn from "classnames";

const TopFoodBeveragePosts: FCX<{
    data: ISocialPost[];
    isLoading: boolean;
    isDark?: boolean;
    showFollowers?: boolean;
    prevIcon?: ReactNode;
    nextIcon?: ReactNode;
}> = ({
    data,
    isLoading,
    isDark,
    showFollowers,
    prevIcon,
    nextIcon,
    className
}) => {
    return (
        <Widget className={cn('TopFoodBeveragePosts', className)}>
            <SocialPosts
                data={data}
                isLoading={isLoading}
                isDark={isDark}
                showFollowers={showFollowers}
                prevIcon={prevIcon}
                nextIcon={nextIcon}
            />
        </Widget>
    );
};

export default TopFoodBeveragePosts;
